import { render } from "./PipelineBoard.vue?vue&type=template&id=0edafd86&scoped=true"
import script from "./PipelineBoard.vue?vue&type=script&lang=js"
export * from "./PipelineBoard.vue?vue&type=script&lang=js"

import "./PipelineBoard.vue?vue&type=style&index=0&id=0edafd86&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edafd86"]])

export default __exports__